export default [
    '#0275d8',
    '#5bc0de',
    '#a3e3fb',
    '#5cb85c',
    '#f0ad4e',
    '#d9534f',
    '#0c4c8c',
    '#8e5847',
    '#a6c5c8',
    '#eb5b2d',
    '#292b2c',
    '#2f6765',
    '#372528',
    '#313725',
    '#2b2537',
    '#25372b'
];